import { z } from "zod";

const schema = z.object({
  title: z.string().min(1, "Title is required"),
  summary: z.string().min(1, "Summary is required"),
  link: z.string().optional(),
  image: z.instanceof(File).optional(),
  project: z.instanceof(File).optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateProjectFormSchema,
  type Schema as CandidateProjectFormSchema,
};
